/* unplugin-vue-components disabled */import script from "./error.vue?vue&type=script&lang=ts&setup=true"
export * from "./error.vue?vue&type=script&lang=ts&setup=true"

import "./error.vue?vue&type=style&index=0&id=df1e4ba8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df1e4ba8"]])

export default __exports__